import 'react';
import {
    Table, TableBody, TableCell,
    TableRow, Typography, Box, TableHead
} from '@mui/material';
import {MoneyField} from '@/components/common/MoneyField';
import {TaxPpe} from "@/services/auditService/interface/tax-com";

interface PpeAdditionTableProps {
    tableTitle: string;
    currency: string | null;
    storeRow: TaxPpe[];
}

export function PpeAdditionTable({
                                     tableTitle,
                                     currency,
                                     storeRow,
                                 }: PpeAdditionTableProps) {
    if (!storeRow || storeRow.length === 0) {
        return null;
    }

    // Calculate total value for numeric column
    const totalValue = storeRow.reduce((sum, row) => sum + (row.value ?? 0), 0);

    return (
        <Box>
            <Table size="small" sx={{tableLayout: 'fixed', width: '100%'}}>
                <colgroup>
                    <col style={{width: '66.6666%'}}/>
                    <col style={{width: '33.3333%'}}/>
                </colgroup>
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                                {tableTitle}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {storeRow.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell align="left" sx={{width: '66.6666%'}}>
                                <Typography variant="body2" sx={{fontWeight: 'bold'}}>
                                    {row.equipmentName}
                                </Typography>
                            </TableCell>
                            <TableCell align="right" sx={{width: '33.3333%'}}>
                                <MoneyField
                                    value={row.value}
                                    editable={false}
                                    currencySymbol={currency || ''}
                                    showCents={false}
                                    align="right"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                    {/* Empty row separator */}
                    <TableRow>
                        <TableCell colSpan={2} sx={{py: 0.25, border: 'none'}}/>
                    </TableRow>
                    {/* Total row: single top border + double bottom border */}
                    <TableRow>
                        <TableCell sx={{border: 'none'}}/>
                        <TableCell
                            align="right"
                            sx={{
                                borderTop: '1px solid #000',
                                borderBottom: '3px double #000',
                                borderLeft: 'none',
                                borderRight: 'none',
                                fontWeight: 'bold',
                            }}
                        >
                            <MoneyField
                                value={totalValue}
                                editable={false}
                                currencySymbol={currency || ''}
                                showCents={false}
                                align="right"
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
}
